import { Link, styled } from "@mui/material";

export const StyledLink = styled(Link)({
  cursor: "pointer",
});
